/* Recenzje Judge.me: na DESKTOPIE (≥768px) przenosimy pod galerię (lewa kolumna),
   na MOBILE (≤767px, układ 1-kolumnowy) zostawiamy w oryginalnym miejscu — po sekcji
   produktu, żeby recenzje były PO opisie/cenie/koszyku/informacjach, nie przed.
   Reaguje na zmianę szerokości/orientacji. Nie działa w Theme Editorze. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var mq = window.matchMedia('(min-width: 768px)');
  var node = null;
  var origParent = null;
  var origNext = null;

  function findNode() {
    if (node && node.isConnected) return node;
    var w = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
    if (!w) return null;
    node = w.closest('.shopify-section') || w;
    return node;
  }

  function apply() {
    var n = findNode();
    if (!n) return false;

    if (!origParent) {
      origParent = n.parentNode;
      origNext = n.nextSibling;
    }

    var target = document.querySelector('[data-js-reviews-target]');

    if (mq.matches) {
      // desktop → pod galerię
      if (target && !target.contains(n)) target.appendChild(n);
    } else {
      // mobile → z powrotem na oryginalne miejsce
      if (origParent && n.parentNode !== origParent) {
        if (origNext && origNext.parentNode === origParent) {
          origParent.insertBefore(n, origNext);
        } else {
          origParent.appendChild(n);
        }
      }
    }
    return true;
  }

  function run() {
    if (apply()) return;
    var obs = new MutationObserver(function () { if (apply()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 12000);
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', apply);
  } else if (mq.addListener) {
    mq.addListener(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
